export default [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
    meta: {
      guestOnly: true,
      tooltip: null,
    },
    beforeEnter: (to, from, next) => {
      window.location.href = '/v2/login';
    },
  },
  {
    path: '/social-login',
    name: 'social-login',
    component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
    meta: {
      guestOnly: true,
      tooltip: null,
    },
    beforeEnter: (to, from, next) => {
      window.location.href = '/v2/social-login';
    },
  },
  {
    path: '/password',
    name: 'password',
    component: () => import(/* webpackChunkName: "password" */ './views/ResetPassword.vue'),
    meta: {
      guestOnly: true,
      tooltip: null,
    },
    beforeEnter: (to, from, next) => {
      window.location.href = '/v2/password';
    },
  },
  {
    path: '/password/:token',
    name: 'reset_password',
    component: () =>
      import(/* webpackChunkName: "password-token" */ './views/ResetNewPassword.vue'),
    meta: {
      guestOnly: true,
      tooltip: null,
    },
    beforeEnter: (to, from, next) => {
      window.location.href = `/v2/reset-password/${to.params.token}`;
    },
  },
];
